import { Box, Flex } from "@chakra-ui/layout"
import { useTranslation } from "react-i18next"

const DragToResizeIcon = () => {
  const { t } = useTranslation()

  return (
    <Flex
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      id="drag-to-resize-icon"
    >
      <Flex
        width="80x"
        height="26px"
        color="white"
        background="black"
        padding={"0 5px"}
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        rounded="4px"
        fontSize="11px"
        fontWeight="medium"
      >
        <Box>{t("DRAG TO RESIZE")}</Box>
      </Flex>
    </Flex>
  )
}

export default DragToResizeIcon
